const toSafeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getDateSeats = (tripDate) => {
  const seats = tripDate?.seatsAvailable;

  return {
    adult: toSafeNumber(
      tripDate?.numberOfSeatsAvailable ?? seats?.numberOfSeatsAvailable
    ),
    children: toSafeNumber(
      tripDate?.numberOfChildrensSeatsAvailable
      ?? seats?.numberOfChildrensSeatsAvailable
    ),
    babies: toSafeNumber(
      tripDate?.numberOfBabiessSeatsAvailable ?? seats?.numberOfBabiessSeatsAvailable
    ),
  };
};

export const mapTripAvailability = (tripDates = []) =>
  tripDates.reduce(
    (acc, tripDate) => {
      const seats = getDateSeats(tripDate);
      return {
        adult: acc.adult + seats.adult,
        children: acc.children + seats.children,
        babies: acc.babies + seats.babies,
      };
    },
    { adult: 0, children: 0, babies: 0 }
  );

export const mapTripPublicationToTableRow = (item) => ({
  ...item,
  availability: mapTripAvailability(item?.tripDates || []),
});
